<script lang="ts" setup>
    import GlobalSearchItem from '@/app/common/models/GlobalSearchItem';

    const props = defineProps<{
        result: GlobalSearchItem;
    }>();
</script>

<template>
    <AppSearchModalResult
        icon="fa-calendar"
        :result="result"
    >
        <template v-slot>
            <span class="block text-sm text-gray-800">
                {{ result.title }}
            </span>
            <span class="block text-xs text-gray-600">
                {{ result.calendarEvent.startsAt.toEUDateString() }} {{ result.calendarEvent.startsAt.toShortTimeString() }} - {{ result.calendarEvent.endsAt.toShortTimeString() }}
            </span>
        </template>
        <template v-slot:right>
            <UsersAvatarList
                :users="result.calendarEvent.users"
                size="w-[24px] h-[24px]"
            />
        </template>
    </AppSearchModalResult>
</template>
